import { registerCtdAction } from './v1';
export const ctdUserInteractionDefinition = {
    id: `ctd-user-interaction`,
    dependencies: {
        featureServices: {
            'featureapp-service': '^1.0.0',
            'layer-manager': '^2.0.0',
            'user-interaction-service': '^2.2.0',
        },
    },
    optionalDependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
        },
    },
    create: ({ featureServices }) => {
        const appName = 'car-technical-details';
        const actionId = 'ctd--open-feature-app';
        const featureService = registerCtdAction(featureServices, appName, actionId);
        return {
            '1.0.0': () => ({
                featureService,
                unbind: () => featureService.unbind(),
            }),
        };
    },
};
//# sourceMappingURL=index.js.map